import React, { useState, useMemo, useCallback, useEffect } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import { FormCustom, Input, Select } from '../../Components/Form/Form';
import ReactPlaceholder from 'react-placeholder/lib';
import Loading from '../../Components/Layout/Styled/Loading';
import Controllers from '../../Api/Controllers';
import AppLayoutPublic from '../Layout/LayoutPublic';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
/* import Slider from 'react-slick'; */

/* function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        />
    );
} */

const CustomersPublico = () => {

    const [ready, setReady] = useState(false)
    // tipo de cliente, si es de Mexico 1, o si es de otro país 2 (USA)
    const [typeCustomers, setTypeCustomers] = useState('')
    const [row, setRow] = useState({
        p_id_customers_sale_public: '',
        p_id_upline: '',
        p_name_upline: '',
        p_name_upline_first: '',
        p_name_customers: '',
        p_last_name_customers: '',
        p_last_name_mot_customers: '',
        p_phone_customers: '',
        p_email_customers: '',
        p_date_birthday_customers: '',
        p_file_photo_customers: '',
        file_photo_customers: '',
        p_id_country: '',
        p_zip_code_customers: '',
        p_department_customers: '',
        p_province_customers: '',
        p_address_customers: '',
        p_ife_customers: '',
        p_curp_customers: '',
        p_rfc_customers: '',
        p_number_secure_social_customers: '',
        p_product_selected: ''
    })

    const [newUser, setNewUser] = useState({
        id_user: '',
        password: '',
        link: '',
    })

    const [isSponsorOk, setIsSponsorOk] = useState(false)
    const [rowsCountry, setRowsCountry] = useState([])

    const [showLoading, setShowLoading] = useState(false)

    const [view, setView] = useState(1);
    const [products, setProducts] = useState([]);

    const params = useParams()

    const country = useMemo(() => {
        if (!row.p_id_country) {
            return
        }

        let finded = rowsCountry.find(t => parseInt(row.p_id_country) === parseInt(t.id_country))

        if (!finded) {
            return
        }
        return {
            label: finded.name_country,
            value: finded.id_country
        }
    }, [row.p_id_country, rowsCountry])

    const handleValidateSponsor = (idCustomer, skipNameValidation = false) => {
        return new Promise((resolve, reject) => {
            setShowLoading(true);

            Controllers.customers.get_customers_validate({
                p_id_customers: idCustomer
            })
                .then(res => {
                    if (res.response === 'warning') {
                        Helpers.toast.construct({
                            toast,
                            ...res
                        });
                        resolve(false);
                        return;
                    }

                    if (!res.data?.id_customers) {
                        setIsSponsorOk(false);
                        setRow({ ...row, p_id_upline: '', p_name_upline: '' });
                        resolve(false);
                    } else {
                        if (skipNameValidation || row.p_name_upline_first.toLowerCase() === res.data.last_name_customers?.substr(0, 3)?.toLowerCase()) {
                            setIsSponsorOk(true);
                            setRow({
                                ...row,
                                p_id_upline: res.data.id_customers,
                                p_name_upline: `${res.data.last_name_customers} ${res.data.last_name_mot_customers} ${res.data.name_customers}`,
                                p_name_upline_first: res.data.last_name_customers?.substr(0, 3)
                            });
                            setView(2);
                            resolve(true);
                        } else {
                            Helpers.toast.construct({
                                toast,
                                response: 'warning',
                                message: 'El apellido del sponsor no coincide con el ingresado'
                            });
                            resolve(false);
                        }
                    }
                })
                .catch(error => {
                    console.error('Error validating sponsor:', error);
                    reject(false);
                })
                .finally(() => setShowLoading(false));
        });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(async () => {

        const loodData = async () => {
            const getCountries = await Controllers.country.get_country();
            setRowsCountry(getCountries.data)

            let getId = localStorage.getItem('id_customers_kit_public')
            let getIdUpline = localStorage.getItem('id_customers_kit_public_upline')

            if (params.id_customers) {
                await handleValidateSponsor(params.id_customers, true);

                console.log('getIdUpline', getIdUpline)
                if (getIdUpline && getIdUpline !== params.id_customers) {
                    localStorage.removeItem('id_customers_kit_public')
                    localStorage.removeItem('id_customers_kit_public_upline')
                }
            }

            getIdUpline = localStorage.getItem('id_customers_kit_public_upline')
            if (getId && getIdUpline) {
                const getCart = await Controllers.customers_publico.get_cart_customers_insert_customers_publico({
                    p_id_customers_sale_public: getId,
                    p_id_upline: getIdUpline
                })

                if (getCart.response === 'success') {
                    const getRow = getCart.data

                    setRow({
                        p_id_customers_sale_public: getRow.id_customers_sale_public,
                        p_id_upline: getRow.id_customers,
                        p_name_upline: getRow.name_upline,
                        p_name_upline_first: getRow.last_name_upline?.substr(0, 3),
                        p_name_customers: getRow.name_customers,
                        p_last_name_customers: getRow.last_name_customers,
                        p_last_name_mot_customers: getRow.last_name_mot_customers,
                        p_phone_customers: getRow.phone_cart,
                        p_email_customers: getRow.email_cart,
                        p_date_birthday_customers: getRow.date_birthday_customers,
                        p_file_photo_customers: '',
                        p_id_country: getRow.id_country,
                        p_zip_code_customers: getRow.zip_code_cart,
                        p_department_customers: getRow.department_cart,
                        p_province_customers: getRow.province_cart,
                        p_address_customers: getRow.address_cart,
                        p_ife_customers: getRow.ine_cart ? getRow.ine_cart : '',
                        p_curp_customers: getRow.curp_cart ? getRow.curp_cart : '',
                        p_rfc_customers: getRow.rfc_customers ? getRow.rfc_customers : '',
                        p_number_secure_social_customers: getRow.number_secure_social_customers,
                        file_photo_customers: getRow.photo_customers,
                    })
                    setTypeCustomers(parseInt(getRow.id_country) > 1 ? 2 : 1)
                    setIsSponsorOk(true)
                    setReady(true)
                } else {
                    localStorage.removeItem('id_customers_kit_public')
                    localStorage.removeItem('id_customers_kit_public_upline')
                    setReady(true)
                }
            } else {
                localStorage.removeItem('id_customers_kit_public')
                localStorage.removeItem('id_customers_kit_public_upline')
                setReady(true)
            }
        }
        loodData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const dataSubmit = useCallback(() => {
        let formData = new FormData()

        for (const key in row) {
            if (typeCustomers === 1) {
                if (key === 'p_number_secure_social_customers') {
                    continue
                }
            } else if (typeCustomers === 2) {
                if (key === 'p_ife_customers' || key === 'p_curp_customers' || key === 'p_rfc_customers') {
                    continue
                }
            }

            if (key === 'p_file_photo_customers') {
                if (row.p_file_photo_customers?.files) {
                    if (row.p_file_photo_customers.files.length > 0) {
                        formData.append('p_file_photo_customers', row.p_file_photo_customers.files[0])
                        continue
                    }
                }
                formData.append('p_file_photo_customers', '')
                continue
            }

            if (key === 'p_ife_customers' || key === 'p_curp_customers' || key === 'p_rfc_customers') {
                formData.append(key, row[key] ? row[key] : '')
            }

            formData.append(key, row[key])
        }

        return formData
    }, [row, typeCustomers])

    const productsRender = useMemo(() => <ReactPlaceholder ready showLoadingAnimation rows={25}>
        <Card>
            <Card.Body className="pb-4" id="carousel_ecommerce">
                {/* <Slider {...{
                    dots: false,
                    arrows: true,
                    infinite: false,
                    speed: 500,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    nextArrow: <SampleNextArrow />,
                    prevArrow: <SampleNextArrow />,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                }}> */}
                <div className="form-row">
                    {React.Children.toArray([
                        ...products,
                    ].map(r => {
                        return <div className="col-xl-6">
                            <div className='p-1 p-lg-4'>
                                <div className="d-flex flex-column p-4 shadow">
                                    <div className="d-flex justify-content-center" style={{
                                    }}>
                                        <img src={Helpers.config.resourcesUrl({ url: r.file_photo })} alt="" className="img-fluid mb-2 align-self-center" style={{ width: 190, maxHeight: 300 }} />
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div className="align-self-center d-flex flex-column">
                                            <strong className="mt-">{r.description_store_product}</strong>
                                            <strong className="mt-">$ {r.price_product}</strong>
                                            <small className="mt-">Puntos {r.point_product}</small>
                                            <small className="mt-">Valor Negocio {r.value_business_product}</small>
                                        </div>
                                        <div className="align-self-center ml-4">
                                            <Button size="sm" variant={'outline-primary'} onClick={_ => {
                                                setShowLoading(true)
                                                Controllers.customers_publico.get_cart_customers_insert_customers_publico_link({
                                                    p_id_customers_sale_public: localStorage.getItem('id_customers_kit_public'),
                                                    p_id_upline: localStorage.getItem('id_customers_kit_public_upline'),
                                                    p_id_product: r.id_product,
                                                    p_qty: 1,
                                                    p_price: r.price_product,
                                                    p_lot: '',
                                                    p_point: r.point_product,
                                                    p_value_business: r.value_business_product,
                                                }).then(res => {
                                                    if (res.response !== 'success') {
                                                        Helpers.toast.construct({ ...res, toast })
                                                        setShowLoading(false)
                                                        return
                                                    }
                                                    setShowLoading(false)
                                                    setNewUser({
                                                        id_user: res.data.id_customers,
                                                        password: res.data.password,
                                                        link: res.data.link_pay
                                                    })
                                                    localStorage.removeItem('id_customers_kit_public')
                                                    localStorage.removeItem('id_customers_kit_public_upline')
                                                    setView(7)
                                                })
                                            }}>
                                                <i className="fa fa-shopping-cart"></i>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br /><br />
                        </div>
                    }))}
                </div>
                {/* </Slider> */}
            </Card.Body>
        </Card>
    </ReactPlaceholder>, [products])

    return <AppLayoutPublic type="clientes">
        <div className="form-row">
            <div className="col-lg-2 col-md-1"></div>
            <div className="col-12 col-lg-8 col-md-12">
                <Card>
                    <Card.Header>
                        Formulario de Inscripción System Devs
                    </Card.Header>
                    <Card.Body>
                        {view <= 5 && <>
                            <ReactPlaceholder ready={ready} rows={15} showLoadingAnimation>
                                <FormCustom viewSubmit={false} onSubmit={() => {
                                    if (view === 1) {
                                        handleValidateSponsor(row.p_id_upline)
                                    } else if (view === 2) {
                                        setView(3)
                                    } else if (view === 3) {
                                        if (!row.p_id_country) {
                                            Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar el país', toast })
                                            return
                                        }
                                        if (typeCustomers === 1) {
                                            setView(4)
                                        } else {
                                            setView(5)
                                        }
                                    } else if (view === 4) {
                                        setView(5)
                                    } else if (view === 5) {
                                        setShowLoading(true)
                                        Controllers.customers_publico.cart_customers_insert_customers_publico(dataSubmit()).then(res => {
                                            Helpers.toast.construct({
                                                ...res,
                                                toast
                                            })
                                            if (res.response === 'success') {
                                                localStorage.setItem('id_customers_kit_public', res.data.id_customers_kit_public)
                                                localStorage.setItem('id_customers_kit_public_upline', res.data.id_customers_kit_public_upline)

                                                Controllers.customers_publico.get_product_for_customers_new({
                                                    p_id_country: row.p_id_country
                                                }).then(res => {
                                                    setProducts(res.data)
                                                    setView(6)
                                                    setShowLoading(false)
                                                })
                                            }
                                        }).finally(_ => setShowLoading(false))
                                    }

                                }} s>
                                    {(view === 1 || view === 2) && (
                                        <>
                                            <p className="col-12 mb-0 font-weight-bold">
                                                Información del sponsor <span className="text-danger"></span>
                                            </p>
                                            <Input
                                                text={<>
                                                    Nro Distribuidor de la persona que te invitó <span className="text-danger"></span> <strong className={`text-${isSponsorOk ? 'success' : ''}`}><i className={`fa fa-${isSponsorOk ? 'check' : 'times1'} mr-1 ml-2`}></i> {isSponsorOk ? 'Verificado' : ''}</strong></>}
                                                placeholder="Nro Distribuidor"
                                                type="number"
                                                classNameParent="col-12 mb-2"
                                                icon="fas fa-sort-numeric-up"
                                                required
                                                invalid="El campo es obligatorio."
                                                value={row.p_id_upline}
                                                min="1"
                                                onChange={e => {
                                                    setRow({ ...row, p_id_upline: e.currentTarget.value, p_name_upline: '' })
                                                    setView(1)
                                                    if (e.currentTarget.value.trim() === '') {
                                                        setIsSponsorOk(false)
                                                        return
                                                    }
                                                    setIsSponsorOk(parseInt(e.currentTarget.value.trim()) === parseInt(row.p_id_sponsor))
                                                }}
                                                size="sm"
                                                disabled={params.id_customers}
                                            />
                                            <Input
                                                text={<>
                                                    Apellido de Sponsor (3 primeras letras) <span className="text-danger"></span>
                                                </>}
                                                placeholder="Apellido de Sponsor"
                                                classNameParent="col-12 mb-2"
                                                icon="far fa-user"
                                                value={row.p_name_upline_first}
                                                required
                                                maxLength={3}
                                                minLength={3}
                                                onChange={e => {
                                                    setRow({ ...row, p_name_upline_first: e.currentTarget.value })
                                                    setView(1)
                                                    setIsSponsorOk(false)
                                                }}
                                                disabled={params.id_customers}
                                            />
                                            {isSponsorOk && view === 2 && (
                                                <>
                                                    <Input
                                                        text={<>
                                                            Sponsor <span className="text-danger"></span>
                                                        </>}
                                                        placeholder="Sponsor"
                                                        classNameParent="col-12 mb-2"
                                                        icon="far fa-user"
                                                        value={row.p_name_upline}
                                                        disabled
                                                    />
                                                    <div className='text-center col-12 mt-4'>
                                                        <strong>¿Tu patrocinador es correcto? <span className="text-danger"></span></strong>
                                                    </div>
                                                    <div className="col-12 mt-3 d-flex justify-content-center">
                                                        <Button
                                                            variant="primary"
                                                            className="mr-2"
                                                            onClick={() => setView(3)}
                                                        >
                                                            Sí, es correcto
                                                        </Button>
                                                        <Button
                                                            variant="danger"
                                                            onClick={() => {
                                                                setView(1);
                                                                setIsSponsorOk(false);
                                                                setRow({
                                                                    p_id_customers_sale_public: '',
                                                                    p_id_upline: '',
                                                                    p_name_upline: '',
                                                                    p_name_upline_first: '',
                                                                    p_name_customers: '',
                                                                    p_last_name_customers: '',
                                                                    p_last_name_mot_customers: '',
                                                                    p_phone_customers: '',
                                                                    p_email_customers: '',
                                                                    p_date_birthday_customers: '',
                                                                    p_file_photo_customers: '',
                                                                    file_photo_customers: '',
                                                                    p_id_country: '',
                                                                    p_zip_code_customers: '',
                                                                    p_department_customers: '',
                                                                    p_province_customers: '',
                                                                    p_address_customers: '',
                                                                    p_ife_customers: '',
                                                                    p_curp_customers: '',
                                                                    p_rfc_customers: '',
                                                                    p_number_secure_social_customers: '',
                                                                    p_product_selected: ''
                                                                });
                                                            }}
                                                        >
                                                            No
                                                        </Button>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}

                                    {view === 3 && <>
                                        <Select
                                            classNameParent="col-12 mb-4"
                                            icon="far fa-flag"
                                            text="País"
                                            options={rowsCountry.map(t => {
                                                return {
                                                    label: t.name_country,
                                                    value: t.id_country
                                                }
                                            })}
                                            value={country}
                                            onChange={e => {
                                                setRow({ ...row, p_id_country: e.value })
                                                setTypeCustomers(e.value === 1 ? 1 : 2)
                                            }}
                                        />
                                        <p className="col-12 mb-0 mt-2 font-weight-bold">Información Cliente</p>
                                        <Input
                                            text="Nombre"
                                            placeholder="Nombre"
                                            classNameParent="col-6 mb-2"
                                            icon="far fa-user"
                                            required
                                            invalid="El campo es obligatorio."
                                            value={row.p_name_customers}
                                            onChange={e => setRow({ ...row, p_name_customers: e.currentTarget.value })}
                                            maxLength={150}
                                        />
                                        <Input
                                            text="Apellido Paterno"
                                            placeholder="Apellido Paterno"
                                            classNameParent="col-6 mb-2"
                                            icon="far fa-user"
                                            required
                                            invalid="El campo es obligatorio."
                                            value={row.p_last_name_customers}
                                            onChange={e => setRow({ ...row, p_last_name_customers: e.currentTarget.value })}
                                            maxLength={150}
                                        />
                                        {typeCustomers === 1 && <Input
                                            text="Apellido Materno"
                                            placeholder="Apellido Materno"
                                            classNameParent="col-6 mb-2"
                                            icon="far fa-user"
                                            required
                                            invalid="El campo es obligatorio."
                                            value={row.p_last_name_mot_customers}
                                            onChange={e => setRow({ ...row, p_last_name_mot_customers: e.currentTarget.value })}
                                            maxLength={150}
                                        />}
                                        <Input
                                            text="Teléfono"
                                            placeholder="Teléfono"
                                            classNameParent="col-6 mb-2"
                                            icon="fa fa-phone"
                                            required
                                            invalid="El campo es obligatorio."
                                            value={row.p_phone_customers}
                                            onChange={e => setRow({ ...row, p_phone_customers: e.currentTarget.value })}
                                            maxLength={30}
                                        />
                                        <Input
                                            text="Email"
                                            type="email"
                                            placeholder="Email"
                                            classNameParent="col-6 mb-2"
                                            icon="fa fa-envelope"
                                            required
                                            invalid="El campo es obligatorio."
                                            value={row.p_email_customers}
                                            onChange={e => setRow({ ...row, p_email_customers: e.currentTarget.value })}
                                            maxLength={50}
                                        />
                                        <Input
                                            type="date"
                                            text="Fecha Nacimiento"
                                            placeholder="Fecha Nacimiento"
                                            classNameParent="col-6 mb-2"
                                            icon="far fa-calendar-alt"
                                            required
                                            invalid="El campo es obligatorio."
                                            value={row.p_date_birthday_customers}
                                            onChange={e => setRow({ ...row, p_date_birthday_customers: e.currentTarget.value })}
                                            maxLength={30}
                                        />

                                        <Input
                                            icon="fa fa-image"
                                            type="file"
                                            text="Imagen"
                                            classNameParent="col-12 mb-2"
                                            accept="image/png, image/jpe"
                                            onChange={e => setRow({ ...row, p_file_photo_customers: e.currentTarget })}
                                        />

                                        {row.file_photo_customers && !row.p_file_photo_customers ? <div className="col-12">
                                            <a href={Helpers.config.resourcesUrl({ url: row.file_photo_customers })} target="_blank" rel="noreferrer">
                                                <img src={Helpers.config.resourcesUrl({ url: row.file_photo_customers })} width="300" alt={row.alt_photo} className="img-thumbnail" />
                                            </a>
                                        </div> : ''}
                                    </>}

                                    {view === 5 && <>
                                        <p className="col-12 mb-0 mt-2 font-weight-bold">Información Domicilio</p>
                                        <Input
                                            text="Código Postal"
                                            placeholder="Código Postal"
                                            classNameParent="col-6 mb-2"
                                            icon="fas fa-map-pin"
                                            required
                                            invalid="El campo es obligatorio."
                                            value={row.p_zip_code_customers}
                                            onChange={e => setRow({ ...row, p_zip_code_customers: e.currentTarget.value })}
                                            maxLength={20}
                                        />
                                        <Input
                                            text="Estado"
                                            placeholder="Estado"
                                            classNameParent="col-6 mb-2"
                                            icon="fas fa-map-marker-alt"
                                            required
                                            invalid="El campo es obligatorio."
                                            value={row.p_department_customers}
                                            onChange={e => setRow({ ...row, p_department_customers: e.currentTarget.value })}
                                            maxLength={100}
                                        />
                                        <Input
                                            text="Ciudad"
                                            placeholder="Ciudad"
                                            classNameParent="col-6 mb-2"
                                            icon="fas fa-map-marker-alt"
                                            required
                                            invalid="El campo es obligatorio."
                                            value={row.p_province_customers}
                                            onChange={e => setRow({ ...row, p_province_customers: e.currentTarget.value })}
                                            maxLength={100}
                                        />
                                        <Input
                                            text="Dirección"
                                            placeholder="Dirección"
                                            classNameParent="col-6 mb-2"
                                            icon="fas fa-map-marker-alt"
                                            required
                                            invalid="El campo es obligatorio."
                                            value={row.p_address_customers}
                                            onChange={e => setRow({ ...row, p_address_customers: e.currentTarget.value })}
                                            maxLength={150}
                                        />
                                    </>}

                                    {view === 4 && <>
                                        <p className="col-12 mb-0 mt-2 font-weight-bold">Información Documentaria</p>

                                        {typeCustomers === 1 ? <>
                                            <Input
                                                text="INE"
                                                placeholder="INE"
                                                classNameParent="col-6 mb-2"
                                                icon="far fa-id-card"
                                                invalid="El campo es obligatorio."
                                                value={row.p_ife_customers}
                                                onChange={e => setRow({ ...row, p_ife_customers: e.currentTarget.value })}
                                                maxLength={30}
                                            />
                                            <Input
                                                text="CURP"
                                                placeholder="CURP"
                                                classNameParent="col-6 mb-2"
                                                icon="far fa-id-card"
                                                maxLength={18}
                                                pattern="[0-9A-Za-z]{18}"
                                                invalid="Por favor, ingresar texto alfumérico de 18 caracteres."
                                                value={row.p_curp_customers}
                                                onChange={e => setRow({ ...row, p_curp_customers: e.currentTarget.value })}
                                                required
                                            />
                                            <Input
                                                text="RFC"
                                                placeholder="RFC"
                                                classNameParent="col-6 mb-2"
                                                icon="far fa-id-card"
                                                value={row.p_rfc_customers}
                                                onChange={e => setRow({ ...row, p_rfc_customers: e.currentTarget.value })}
                                                maxLength={13}
                                                pattern="[0-9A-Za-z]{13}"
                                                invalid="Por favor, ingresar texto alfumérico de 13 caracteres."
                                            />
                                        </> : <Input
                                            text="Número Seguro"
                                            placeholder="Número Seguro"
                                            classNameParent="col-6 mb-2"
                                            icon="far fa-id-card"
                                            invalid="El campo es obligatorio."
                                            value={row.p_number_secure_social_customers}
                                            onChange={e => setRow({ ...row, p_number_secure_social_customers: e.currentTarget.value })}
                                            maxLength={30}
                                        />}
                                    </>}

                                    <div className="col-12 text-center mt-4 d-flex justify-content-center">
                                        {view >= 3 && <Button onClick={_ => {
                                            if (view === 5) {
                                                if (typeCustomers === 1) {
                                                    setView(4)
                                                } else {
                                                    setView(3)
                                                }
                                            } else {
                                                setView(view - 1)
                                            }
                                        }} className='mr-3' variant="secondary" disabled={view === 1}>
                                            <i className='fa fa-arrow-left'></i>
                                            <span className='ml-2'>Anterior</span>
                                        </Button>}
                                        {view === 1 && <div className='d-flex flex-column'>
                                            <Button type="submit" className='align-self-center'>
                                                <i className='fa fa-check'></i>
                                                <span className='ml-2'>Buscar Sponsor</span>
                                            </Button>
                                            <div className='mt-2'>
                                                <p>Comparte los datos de tu patrocinador para asegurar que formes parte de su
                                                    equipo y juntos construyan un camino de bienestar * y abundancia.</p>
                                            </div>
                                        </div>}
                                        {!(isSponsorOk && view === 2) && view >= 2 && view < 5 && <Button type="submit">
                                            <span className='mr-2'>Siguiente</span>
                                            <i className='fa fa-arrow-right'></i>
                                        </Button>}
                                        {view === 5 && <Button type="submit" variant="success">
                                            <i className='fa fa-check'></i>
                                            <span className='ml-2'>Enviar datos</span>
                                        </Button>}
                                    </div>
                                </FormCustom>
                            </ReactPlaceholder>
                        </>}

                        {view === 6 && <>
                            <div className="mb-0 font-weight-bold">
                                Paquetes de Inicio
                            </div>
                            <div className="form-row">
                                <div className="col-12 mt-4">
                                    {productsRender}
                                </div>
                            </div>
                            <div className="col-12 text-center mt-4 d-flex justify-content-center">
                                {<Button onClick={_ => {
                                    setView(5)
                                }} className='mr-3' variant="secondary">
                                    <i className='fa fa-arrow-left'></i>
                                    <span className='ml-2'>Anterior</span>
                                </Button>}
                            </div>
                        </>}

                        {view === 7 && <>
                            <div className="mb-2 font-weight-bold text-center">
                                ¡Bienvenido a System Devs!
                            </div>
                            {/* <div className="mb-2 font-weight-bold text-success text-center">
                                Tu membresía está activa. <br />Revisa tu correo electrónico, hemos enviado más información.
                            </div> */}
                            <div className="mb-2 font-weight-bold text-center">
                                Te damos la bienvenida con los brazos abiertos a esta comunidad que
                                vibra en bienestar, salud y propósito. <br />
                                Prepárate para crecer, ayudar y transformar tu vida y la de muchos más.
                                Estás exactamente donde tenías que estar. 🌟
                            </div>
                            <div className="mb-0 font-weight-bold text-center text-lg">
                                <h2>ID: {newUser.id_user}<br />
                                    Password: {newUser.password}<br /></h2>
                            </div>
                            <div className="col-12 text-center mt-4 d-flex justify-content-center">
                                {<Button onClick={_ => {
                                    window.location.href = newUser.link
                                }} className='mr-3' variant="primary">
                                    <i className='fa fa-dollar'></i>
                                    <span className='ml-2'>Pagar Ahora</span>
                                </Button>}
                            </div>
                        </>}
                    </Card.Body>
                </Card>
            </div>
        </div>
        <Loading show={showLoading}>
            <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
        </Loading>
    </AppLayoutPublic>
}

export default CustomersPublico
